import { Typography } from "antd";
import { useNavigate } from "react-router-dom";
import eventBus from "src/common/eventBus";
import { Button } from "src/components";
import {
  Form,
  FormDatePicker,
  FormNumber,
  FormText,
  FormSelect,
} from "src/components/Form";
import api from "src/config/api";

const CreateBike = () => {
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    try {
      await api.post("bikes", data);
      eventBus.emit("dialog", {
        type: "success",
        message: "Bike created successfully!",
      });
      setTimeout(() => {
        navigate("/bikes");
        eventBus.emit("dialog", {
          open: false,
        });
      }, 2000);
    } catch (error) {
      eventBus.emit("dialog", {
        type: "error",
        message: error.response?.data?.message || "Something went wrong",
      });
    }
  };
  
  return (
    <>
      <Typography.Title level={4} className="mb-4">
        Create Bike
      </Typography.Title>
      <Form onSubmit={handleSubmit} layout="horizontal">
        <FormText
          label="Bike Name"
          placeholder="Bike Name"
          name="bikeName"
          required
        />
        <FormText
          label="License Number"
          placeholder="License Number"
          name="licenseNumber"
        />
        <FormText
          label="Owner"
          placeholder="Owner"
          name="owner"
        />
        <FormNumber 
          label="Purchase Price" 
          placeholder="Purchase Price" 
          name="purchasePrice" 
        />
        <FormDatePicker
          label="Last Oil Change"
          placeholder="Last Oil Change"
          name="lastOilChange"
        />
        <FormText
          label="Insurance"
          placeholder="Insurance"
          name="insurance"
        />
        <FormNumber
          label="Kilometers Run"
          placeholder="Kilometers Run"
          name="kilometersRun"
        />
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form>
    </>
  );
};

export default CreateBike; 